export default __webpack_public_path__ + "static/media/open-interest.8a27cec8.png";